import { Injectable } from '@angular/core';

type ThemeMode = 'dark' | 'light';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly storageKey = 'draed-portfolio-theme';

  getPreferredTheme(): ThemeMode {
    const stored = localStorage.getItem(this.storageKey) as ThemeMode | null;
    return stored ?? 'dark';
  }

  setTheme(mode: ThemeMode): void {
    document.documentElement.setAttribute('data-theme', mode);
    localStorage.setItem(this.storageKey, mode);
  }

  toggleTheme(current: ThemeMode): ThemeMode {
    const next = current === 'dark' ? 'light' : 'dark';
    this.setTheme(next);
    return next;
  }
}
